import styled from "styled-components";
import { shade0 } from "@songtradr-one/components-frontend";
import { graphql } from "../../../generated/gql";
import { staticText } from "../../../shared/statics/static-text";
import { NotificationsPanelTab } from "../NotificationsPanel.Parts";

// TEXT
export const text = staticText.panel;

// STYLES
export const MarkAllReadButton = styled.button`
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  border: none;
  background: none;
  color: ${shade0};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

// DATA
export const NotificationsPanelTabs_ClearUnread = graphql(`
  mutation NotificationsPanelTabsClearUnread {
    clearUnreadNotifications
  }
`);

// TYPES
export type Props = {
  activeTab: NotificationsPanelTab;
  setActiveTab: (tab: NotificationsPanelTab) => void;
  unread: number;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
